// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"783":"d038f26030071f1b","9323":"08010d8ece74c182"}[chunkId] + ".css";
};